<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center">

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

            <mat-card class="login-card mat-elevation-z8" [class.spinner]="loading">
                <mat-card-title>Login</mat-card-title>
                <mat-card-content fxLayout="column">
                    <mat-form-field>
                        <input matInput formControlName="email" type="email" placeholder="E-mail" autocomplete="email"
                            readonly="false">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput formControlName="password" type="password" placeholder="Password"
                            autocomplete="password">
                    </mat-form-field>
                </mat-card-content>

                <mat-card-actions fxLayoutAlign="end">
                    <button mat-raised-button color="warn" (click)="loginGoogle()" type="button"
                        [disabled]="loading">Google Login</button>
                    <button mat-raised-button color="primary" type="submit" [disabled]="loading || loginForm.invalid">
                        <mat-icon>check</mat-icon>Login
                    </button>
                    <!-- <button mat-button color="accent" routerLink="/auth/forgot">
                            <mat-icon>lock_open</mat-icon><u> ESQUECI A SENHA</u>
                        </button> -->
                </mat-card-actions>
            </mat-card>
        </form>

    </div>
</div>